










import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
  props: ['idName', 'nostyle'],
})

export default class EmojiRating extends Vue {
    idName: string;
    nostyle: boolean;
    private value = 0;
    private hoverState = [false, false, false, false, false];
    private realState = [false, false, false, false, false];

    private hovering(n) {
        this.hoverState = [false, false, false, false, false];
        Vue.set(this.hoverState, n-1, true)
    }

    private reset() {
        for (let i = 0; i < 5; i++)
            Vue.set(this.hoverState, i, this.realState[i]);
    }

    private clicked(n) {
        this.hoverState = [false, false, false, false, false];
        this.realState = [false, false, false, false, false];
        this.value = n;
        this.$emit('emojiClicked', {value: n, name: this.idName});
        Vue.set(this.hoverState, n-1, true);
        Vue.set(this.realState, n-1, true);
    }
}
